import { ofType } from "redux-observable";
import { mergeMap, debounceTime } from "rxjs/operators";
import { merge, of } from "rxjs";

import { GET_ORGANIZATION_INFO } from "../types";
import {
  getOrganizationInfoPending,
  getOrganizationInfoFulfilled,
  getOrganizationInfoRejected,
} from "../actions";

import {
  sendApiRequest,
  //  notifyError, notifyWarning
} from "../../../actions";

// import { ORGANIZATION_MESSAGES } from '../constants/organizationMessages'
// import generateError from '../../../utilities/generateError';

const createPayload = (payload) => ({
  method: "get",
  url: "organization/current",
  onSuccess: [
    (response) =>
      response.data.length === 0
        ? getOrganizationInfoFulfilled([])
        : //  notifyWarning(ORGANIZATION_MESSAGES.NOT_FOUND)
          getOrganizationInfoFulfilled(response),
  ],
  onError: [
    getOrganizationInfoRejected,
    (error) => getOrganizationInfoFulfilled([]),
    // notifyError(generateError(error)),
  ],
  data: payload,
});

const meta = {
  api: "ajaxApi",
};

const getOrganizationInfoEpic$ = (action$, state$) =>
  action$.pipe(
    ofType(GET_ORGANIZATION_INFO.DEFAULT),
    debounceTime(500),
    mergeMap(({ payload }) => {
      return merge(
        of(getOrganizationInfoPending()),
        of(sendApiRequest(createPayload({ ...payload }), meta))
      );
    })
  );

export default getOrganizationInfoEpic$;



// WEBPACK FOOTER //
// ./src/features/organization/epics/getOrganizationInfoEpic.js